import { useCapabilityContext } from "@/providers/CapabilitiesProvider";

export function useUpgradeModal() {
  const { openUpgradeModal } = useCapabilityContext();
  return { openUpgradeModal };
}
